
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GroupScope } from '@/components/mixins/groupscope';
import MemberBadge from '@/components/coach/members/MemberBadge.vue';
import { Badge } from '@/models/group';
import { Member } from '@/models/member';

@Component({
  name: 'Badges',
  components: { MemberBadge },
})
export default class Badges extends mixins(GroupScope) {
  /**
   * Created hook, runs before component is mounted.
   * Makes sure the relevant group information is fetched from the IDB/API for this and nested pages.
   *
   * @return {void}
   */
  created(): void {
    this.loadGroup();
  }

  get members() {
    return this.groupMembers.filter((record: Member) => record.in);
  }

  get badges(): Array<Badge> {
    return this.group.badges || [];
  }
}
